const getOfferAlertDismissalKey = (alert) => {
  if (!alert?.product || !alert?.request_id) return null;
  return `sl-offer-alert-dismissed:${alert.product}:${alert.request_id}:${alert.offer_count || 0}`;
};

export const shouldShowOfferAlert = (alert) => {
  const key = getOfferAlertDismissalKey(alert);
  if (!alert?.has_offer_alert || !key) return false;

  try {
    return window.sessionStorage.getItem(key) !== "1";
  } catch (error) {
    return true;
  }
};

export const dismissOfferAlert = (alert) => {
  const key = getOfferAlertDismissalKey(alert);
  if (!key) return;

  try {
    window.sessionStorage.setItem(key, "1");
  } catch (error) {
    // Ignore storage failures; the alert can still be closed in component state.
  }
};
